export const URL_ACTIVITY_REPORT = 'report-summary';
export const URL_ACTIVITY_REPORT_STUDENTS = 'report-students';
export const URL_ACTIVITY_REPORT_TEACHERS = 'report-teachers';
